module.exports = __webpack_public_path__ + "static/dev.notnoob-d727e8106e260d475e27fa4b247fc44a.jpg";